import { FC, useState } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@tempmee/react';
import { useUserSelector } from '~/hooks/useUserSelector';
import { routes } from '~/routes';
import { POSTHOG_EVENTS, trackPosthogEvent } from '~/services/posthog';
import { fireProfessionalTypePopupViewed, fireProfessionalTypeSelected } from '~/posthogs/events';
import { SelectProfessionTypePopup } from '../SelectProfessionType/SelectProfessionTypePopup';
import { useSelectProfessionType } from '../SelectProfessionType/useSelectProfessionType';

interface IPostNewShiftsButtonProps {
  text?: string;
  disabled?: boolean;
  style?: React.CSSProperties;
  textStyle?: React.CSSProperties;
}

export const PostNewShiftsButton: FC<IPostNewShiftsButtonProps> = ({
  text = 'Post Shifts',
  disabled = false,
  style,
  textStyle,
}) => {
  const navigate = useNavigate();
  const user = useUserSelector();
  const officeState = user?.address?.[0]?.state ?? '';

  const [isShowPopup, setIsShowPopup] = useState(false);

  const { availableProfessions } = useSelectProfessionType({ officeState });

  const handleClick = () => {
    trackPosthogEvent(POSTHOG_EVENTS.OFFICE_DASHBOARD_SHIFT_REQUEST_CLICKED);
    fireProfessionalTypePopupViewed();
    setIsShowPopup(true);
  };

  const handleContinue = (professionCode: string) => {
    fireProfessionalTypeSelected();
    setIsShowPopup(false);
    navigate(routes.selectDates, {
      state: { professionType: professionCode, inviteSource: 'Shift Request' },
    });
  };

  const handleClose = () => {
    setIsShowPopup(false);
  };

  return (
    <>
      <Button
        disabled={disabled}
        // width 206 has no DS size token; kept as inline style for the dashboard top-button row
        style={{ width: 206, ...style }}
        size="md"
        onClick={handleClick}
      >
        <span style={textStyle}>{text}</span>
      </Button>
      {isShowPopup && (
        <SelectProfessionTypePopup
          professions={availableProfessions}
          onContinue={handleContinue}
          onClose={handleClose}
        />
      )}
    </>
  );
};
